<template>
  <div class="container">
    <div class="handle-box">
      <el-form ref="queryForm" :model="queryForm" label-position="right" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="单据编号" prop="reportNo">
                  <el-input class="handle-input" v-model="queryForm.reportNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="版本" prop="includeHistory">
                  <el-select class="handle-input" v-model="queryForm.includeHistory" placeholder="请选择">
                    <el-option label="含历史版本" value="Y"></el-option>
                    <el-option label="最新" value="N"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="产品" prop="fiveBitCodeName">
                  <el-input class="handle-input" v-model="queryForm.fiveBitCodeName" clearable @focus="showTemplateName" @clear='clearFiveBitCodeName' style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Facility编号" prop="supplierCode">
                  <el-input class="handle-input" v-model="queryForm.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Facility名称" prop="plantName">
                    <el-input class="handle-input" v-model="queryForm.plantName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="评估人" prop="rater">
                    <el-autocomplete class="inline-input" v-model="queryForm.rater" :fetch-suggestions="querySearch" placeholder="请输入内容" clearable style="width:100%">
                      <el-button slot="append" icon="el-icon-search" @click="searchRater()"></el-button>
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="生产日期(从)" prop="beginDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryForm.beginDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="生产日期(至)" prop="endDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryForm.endDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Sample Source" prop="sampleSource">
                    <IcSelect table="TT_PROCESS_SENSORY" field="SAMPLE_SOURCE" v-model="queryForm.sampleSource" clearable style="width:100%"></IcSelect>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="确认状态" prop="status">
                    <IcSelect :excludes="excludesValue" table="TT_SENSORY" field="REPORT_STATUS" v-model="queryForm.status" clearable style="width:100%"></IcSelect>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" type="primary" @click="getData(1)">{{$t("common.search")}}</el-button>
          <el-button size="mini" type="primary" @click="restQueryForm()">{{$t("common.reset")}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <el-row class="action-btn-row">
      <el-button size="mini" class='btn' type="primary" v-acl="PROC_LOT_RECORD_VIEW" @click="exportList">总览报表</el-button>
      <el-button size="mini" class='btn' type="primary" v-acl="PROC_LOT_RECORD_VIEW" @click="onExport">详情报表</el-button>
      <el-button size="mini" class='btn' type="primary" v-acl="PROC_LOT_RECORD_VIEW" @click="onDetail">详情报告</el-button>
      <el-button size="mini" class='btn' type="primary" v-acl="PROC_LOT_RECORD_ADD" @click="onChange">变更</el-button>
    </el-row>
    <el-table :data="dataList" @selection-change="handleSelectionChange" ref="dataList" border highlight-current-row>
      <el-table-column fixed width="56px" type="selection" :label="$t('common.select')" align="center">
      </el-table-column>
      <el-table-column show-overflow-tooltip fixed label="单据编号" prop="reportNo" width="120px">
        <template slot-scope="scope">
          <el-link class="el-link" @click="toDetail(scope.row)">{{scope.row.reportNo}}</el-link>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="版本" prop="version" min-width="70px">
        <template slot-scope="scope">v{{scope.row.version}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="产品" prop="fiveBitCodeName" min-width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip label="Facility编号" prop="supplierCode" min-width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip label="Facility名称" prop="plantName" min-width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip label="生产日期" prop="prodDate">
        <template slot-scope="scope">{{scope.row.prodDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="评估人" prop="rater"></el-table-column>
      <el-table-column show-overflow-tooltip label="Sample Source" prop="sampleSource" min-width="100">
        <template slot-scope="scope">{{scope.row.sampleSource | ic("TT_PROCESS_SENSORY","SAMPLE_SOURCE")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="单据状态" prop="status">
        <template slot-scope="scope">{{scope.row.status | ic("TT_SENSORY","REPORT_STATUS")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="备注" prop="remark"></el-table-column>
      <el-table-column show-overflow-tooltip label="模板名称" prop="templateName" width="150px"></el-table-column>
      <el-table-column show-overflow-tooltip label="模板版本" prop="templateVersion" width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip label="是否变更" prop="changed" :formatter="formatChangedStatus" width="180px"></el-table-column>
      <el-table-column show-overflow-tooltip label="创建人" prop="creator" min-width="120"></el-table-column>
      <el-table-column show-overflow-tooltip label="创建日期" prop="createDate">
        <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="更新人" prop="creator" min-width="120"></el-table-column>
      <el-table-column show-overflow-tooltip label="更新日期" prop="createDate">
        <template slot-scope="scope">{{scope.row.updateDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip v-if="queryForm.status == 'CANCLE'" label="禁用原因" prop="inactiveReason"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination :page-sizes="[10,15,50,100]" @size-change="pageSizeChange($event,'queryForm','getData')" :page-size="queryForm.pageSize" :current-page="queryForm.pageNum" @current-change="pageNumberChange($event,'queryForm','getData')" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog :visible.sync="showRaterDialog" append-to-body width="80%" title="评估人选择器">
      <pickupUser @input="selectRater" :multi="true"></pickupUser>
    </el-dialog>
    <el-dialog :visible.sync="showTemplateNameDialog" append-to-body width="80%" title="产品选择器">
      <PickupFiveBitCode @pickup="selectTemplateName" v-if="TemplateNameDialogReset"></PickupFiveBitCode>
    </el-dialog>

    <el-dialog :visible.sync="changeDialog" append-to-body width="70%" title="变更品评报告" :close-on-click-modal="false" :close-on-press-escape="false">
      <changeDialog v-if="changeDialog"></changeDialog>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import pickupUser from "@/components/page/sensory/sensory-template/choiceUser";
import report from "@/api/sensory/processReport";
import dataTableUtils from "@/utils/dataTableUtils";
import { fileService } from "@/api/common/file-utils";
import PickupPlant from "@/components/page/sensory/pickupPlant";
import PickupFiveBitCode from "@/components/page/sensory/sensory-template/templateName";
import fiveBitCode from "@/api/base-data/fiveBitCode";
import paginationMixin from '@/mixins/pagitionMixin';

import changeDialog from "./changeDialog.vue";
export default {
  mixins: [paginationMixin],
  name: "process-sensory-report-list",
  components: { PickupFiveBitCode, PickupPlant, pickupUser, IcSelect, changeDialog },
  props: {
    fiveBitCodeName: String,
    fiveBitCode: String,
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      emplFlag: null,
      excludesValue: [],
      queryForm: {
        pageSize: 15,
        pageNum: 1,
        rater: '',
        reportNo: '',
        fiveBitCodeName: '',
        plantName: "",
        remark: '',
        sampleSource: "",
        status: "",
        beginDate: "",
        endDate: "",
        supplierCode: "",
        plantName: "",
        includeHistory: "N"
      },
      TemplateNameDialogReset: false,
      fiveBitCodeObj: {},
      total: null,
      dataList: [],
      showTemplateNameDialog: false,
      showRaterDialog: false,

      username: '',
      multipleSelection: [],
      ttSensoryReportIdLists: [],
    }
  },
  filters: {
    changedFilter(val, row) {
      console.log('val :', val);
      console.log('row :', row);
      if (val == 'Y') {
        return row.changedInfo
      } else if (val == 'N') {
        return '否'
      }
    }
  },
  created() {
    this.username = localStorage.getItem("ms_username");
    this.emplFlag = localStorage.getItem("ms_emplFlag");
    this.excludesValue = ['CANCLE'];
    this.getData();
  },
  extends: dataTableUtils,
  methods: {
    getData(val) {
      let that = this
      if (undefined != val) {
        this.queryForm.pageNum = 1;
      }
      report.queryReport(this.queryForm).then(resp => {
        this.total = resp.totalCount;
        this.dataList = resp.resultData;
      })
      if (this.fiveBitCode) {
        fiveBitCode.getDetail(this.fiveBitCode).then(res => {
          that.fiveBitCodeObj = {
            categoryLevel1Code: res.data.categoryLevel1Code,
            categoryLevel2Code: res.data.categoryLevel2Code,
            categoryLevel3Code: res.data.categoryLevel3Code,
            fiveBitCode: res.data.fiveBitCode,
            fiveBitCodeName: res.data.fiveBitCodeName,
          }
        })
      }
    },
    formatChangedStatus(row) {
      if (row.changed === "Y") {
        return row.changedInfo;
      } else if (row.changed === "N") {
        return "否";
      }
    },
    handleSelectionChange(val) {
      console.log("GY🚀 ~ handleSelectionChange ~ val:", val);
      this.multipleSelection = val
      this.ttSensoryReportIdLists = val.map(ele => ele.ttSensoryReportId)
    },
    exportList() {
      let that = this;
      report.exportList(that.queryForm).then(fileService.respToFile);
    },
    onExport() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error('只能选择一条数据')
        return false
      }
      report.exportDetail(this.multipleSelection[0].ttSensoryReportId).then(fileService.respToFile);
    },
    onChange() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error('只能选择一条数据')
        return false
      }
      report.changeSensory(this.multipleSelection[0].ttSensoryReportId).then(resp => {
        console.log('resp :', resp);
        this.$router.push({
          path: `/processSensoryReport-edit`,
          query: {
            id: resp.data.ttSensoryReportId,
            type: 'change'
          }
        })
      })
    },
    onDetail() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      report.exportPrintExcel(this.ttSensoryReportIdLists).then(fileService.respToFile);
    },

    // 选择评估人
    searchRater() {
      this.showRaterDialog = true
    },
    selectRater(list) {
      let that = this
      if (list.length > 0) {
        that.queryForm.rater = list.map(data => data.name).join(',');
      }
      that.showRaterDialog = false
    },
    // 选择产品
    showTemplateName() {
      this.showTemplateNameDialog = true;
      this.TemplateNameDialogReset = true
    },
    selectTemplateName(list) {
      this.fiveBitCodeObj = list;
      let that = this;
      that.queryForm.fiveBitCodeName = list.fiveBitCodeName;
      that.queryForm.fiveBitCode = list.fiveBitCode;
      this.showTemplateNameDialog = false;
    },
    clearFiveBitCodeName() {
      this.fiveBitCodeObj = {}
      this.fiveBitCode = ''
      this.fiveBitCodeName = ''
      this.TemplateNameDialogReset = false
      this.$nextTick(() => {
        this.TemplateNameDialogReset = true
      })
    },
    // 评估人选择
    querySearch(queryString, cb) {
      var restaurants = [{ value: "QA LAB" }];
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // 进入详情
    toDetail(row) {
      this.$router.push({
        path: `/processSensoryReport-edit`,
        query: {
          id: row.ttSensoryReportId,
          type: row.status == 'SUBMIT' ? 'view' : 'edit'
        }
      })
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryForm.resetFields();
      this.fiveBitCodeObj = {};
      this.queryForm = {
        pageSize: 15,
        pageNum: 1,
        rater: '',
        reportNo: '',
        fiveBitCodeName: '',
        plantName: "",
        remark: '',
        sampleSource: "",
        status: "",
        beginDate: "",
        endDate: "",
        supplierCode: "",
        plantName: "",
        includeHistory: "N"
      }
      this.getData();
    },

  },
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
.el-date-editor--daterange.el-input__inner {
  width: auto;
}

.el-date-editor--daterange.el-input__inner {
  width: auto;
}

.el-table > .el-table__fixed-right {
  height: 100% !important; //设置高优先，以覆盖内联样式
}
.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
.el-link {
  text-decoration: underline;
  color: #f8ab01 !important;
  cursor: pointer;
  font-size: 12px;
}
</style>
<style lang="scss">
.sensoryReportList {
  .queryForm {
    .el-form-item__content {
      .handle-input {
        width: 100%;
      }
      .el-autocomplete {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
